import { quickFilters } from "@/mocks/home";

type ToolStripProps = {
  active: string;
  onChange: (key: string) => void;
};

export default function ToolStrip({ active, onChange }: ToolStripProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-5 px-4 py-5 md:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-4">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-database-2-line text-xl"></i>
          </span>
          <div className="min-w-[180px]">
            <div className="flex items-center justify-between gap-4 text-xs text-foreground-600">
              <span>本周收录进度</span>
              <span className="font-semibold text-foreground-900">84%</span>
            </div>
            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-300">
              <div className="h-full w-[84%] rounded-full bg-primary-500"></div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
          {quickFilters.map((filter) => {
            const isActive = active === filter.key;
            return (
              <button
                key={filter.key}
                type="button"
                onClick={() => onChange(filter.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-semibold transition-colors md:text-sm ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                }`}
              >
                {filter.label}
              </button>
            );
          })}
        </div>

        <div className="flex items-center gap-3 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-base text-secondary-500"></i>
            上次同步 · 2 小时前
          </span>
          <span className="hidden h-4 w-px bg-background-300 md:block"></span>
          <span className="hidden items-center gap-1.5 md:flex">
            <i className="ri-sort-desc text-base text-foreground-500"></i>
            按更新倒序
          </span>
        </div>
      </div>
    </section>
  );
}